// ─── Mode qualité automatique (fonction pure) ───
// Entrée : état précédent + mesure courante ; sortie : nouvel état et, s'il y a
// lieu, le cran à appliquer. Aucun accès au DOM ni à l'horloge : `now` est fourni,
// ce qui rend l'algorithme relisible et testable.
//
// Mesure : délai moyen (ms) entre l'envoi de `recu{seq}` et l'arrivée de l'image
// suivante, sur ~3 s, débarrassé de l'attente normale due à « images par seconde ».
// Descente : délai > 400 ms pendant 3 s ; remontée : < 150 ms pendant 10 s ;
// au plus un changement toutes les 3 s (sinon pompage).

/** Crans du plus fidèle au plus économe : la qualité baisse d'abord, puis l'échelle. */
export const LADDER = [
  { qualite: 70, echelle: 100 },
  { qualite: 55, echelle: 100 },
  { qualite: 40, echelle: 100 },
  { qualite: 30, echelle: 100 },
  { qualite: 30, echelle: 75 },
  { qualite: 30, echelle: 50 },
];

export const AUTO = { slowMs: 400, fastMs: 150, slowForMs: 3000, fastForMs: 10000, minGapMs: 3000 };

export const initialAutoState = () => ({ level: 0, slowSince: null, fastSince: null, lastChangeAt: -Infinity });

/**
 * @param {{level:number, slowSince:number|null, fastSince:number|null, lastChangeAt:number}} state
 * @param {{now:number, avgDelayMs:number|null}} m  avgDelayMs null = pas d'échantillon (écran immobile)
 * @returns {{state: object, change: {qualite:number, echelle:number}|null}}
 */
export function nextAutoSetting(state, m) {
  const { now, avgDelayMs } = m;
  if (avgDelayMs == null) return { state: { ...state, slowSince: null, fastSince: null }, change: null };

  let { slowSince, fastSince } = state;
  slowSince = avgDelayMs > AUTO.slowMs ? slowSince ?? now : null;
  fastSince = avgDelayMs < AUTO.fastMs ? fastSince ?? now : null;

  const canChange = now - state.lastChangeAt >= AUTO.minGapMs;
  let level = state.level;
  let changed = false;
  if (canChange && slowSince != null && now - slowSince >= AUTO.slowForMs && level < LADDER.length - 1) {
    level++;
    changed = true;
  } else if (canChange && fastSince != null && now - fastSince >= AUTO.fastForMs && level > 0) {
    level--;
    changed = true;
  }
  if (!changed) return { state: { ...state, slowSince, fastSince }, change: null };
  // Après un changement les mesures d'avant ne valent plus : on repart de zéro.
  return {
    state: { level, slowSince: null, fastSince: null, lastChangeAt: now },
    change: LADDER[level],
  };
}
